$(document).ready(function(){

    $('.js-google-login').click(function(){

        $.getScript( "https://apis.google.com/js/api:client.js", function( data, textStatus, jqxhr ) {

            gapi.load('client:auth2',  {
                callback: function() {
                    // Initialize client & auth libraries
                    gapi.client.init({
                        //	apiKey: 'YOUR_GOOGLE_API_KEY',
                        clientId: '832735346213-fmhpivcqlc4esple12e4vlh4bec0o2uf.apps.googleusercontent.com',
                        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/plus.me'
                    }).then(
                        function(success) {

                            gapi.auth2.getAuthInstance().signIn().then(
                                function(success) {

                                    gapi.client.request({ path: 'https://www.googleapis.com/plus/v1/people/me' }).then(
                                        function(success) {
                                            // API call is successful

                                            var user_info = JSON.parse(success.body);

                                            var data = {
                                                action: 'google_login',
                                                google_id: user_info.id,
                                                google_email: user_info.emails[0].value,
                                                google_name: user_info.displayName,
                                                user_helper : $('#user_helper').val()
                                            };

                                            jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data, function(response) {

                                                location.reload();

                                            });

                                        },
                                        function(error) {
                                            // Error occurred
                                            // console.log(error) to find the reason
                                        }
                                    );
                                },
                                function(error) {
                                    console.log('user closed login window');
                                }
                            );

                        },
                        function(error) {
                            var acc = []
                            $.each(error, function(index, value) {
                                acc.push(index + ': ' + value);
                            });
                            alert(JSON.stringify(acc));

                        }
                    );
                },
                onerror: function() {
                    alert('error 2');
                }
            });

        });
    });

    $('.js-facebook-login').click(function(){

        $.ajaxSetup({ cache: true });
        $.getScript('//connect.facebook.net/en_US/all.js', function(){

            FB.init({
                appId: '1670071983136314',
                cookie: true,
                oauth: true,
                version: 'v20.0'
            });

            FB.login(function(response){
                if(response.authResponse){

                    FB.api('/me?fields=email,name', function(responseFromFB){

                        var data = {
                            action: 'facebook_login',
                            fb_id: responseFromFB.id,
                            fb_email: responseFromFB.email,
                            fb_name: responseFromFB.name,
                            user_helper : $('#user_helper').val()

                        };

                        jQuery.post(BASE_URL+'/wp-admin/admin-ajax.php', data, function(response) {
                            location.reload();
                        });
                    });
                }
                else{
                    console.log('The login failed because they were already logged in');
                }
            }, {scope:'email,public_profile'});
        });
    })
})
